module.exports = {
        srcSet: __webpack_public_path__ + "static/media/IS24_Coupon-500.f2901dcd.webp"+" 500w",
        images: [{path: __webpack_public_path__ + "static/media/IS24_Coupon-500.f2901dcd.webp",width: 500,height: 500}],
        src: __webpack_public_path__ + "static/media/IS24_Coupon-500.f2901dcd.webp",
        toString: function(){return __webpack_public_path__ + "static/media/IS24_Coupon-500.f2901dcd.webp"},
        
        width: 500,
        height: 500
      }